import { trackEvent } from "./trackEvent"

export interface TrackButtonClickOptions {
  /**
   *  An id used specifically for tracking.
   */
  trackingId?: string

  /**
   *  The unstranslated name of the button.
   */
  buttonName?: string
}

/**
 *  Track a button click event. This will send the information to our analytics platform.
 *  If there is no trackingId or buttonName, the event will not be tracked.
 */
export function trackButtonClick({ trackingId, buttonName }: TrackButtonClickOptions) {
  if (!trackingId?.trim() && !buttonName?.trim()) {
    return
  }

  trackEvent("button_click", {
    button_id: trackingId ?? "",
    button_text: buttonName ?? "",
  })
}
